import Backbone from 'backbone'
import store from '../../store'

export var HeaderModel = Backbone.Model.extend({
  defaults: function () {
    return {
      onSubmenu: 0,
      hotdeal: false, // 핫딜 상품이 없으면 탭 매뉴 삭제
    }
  },
  onCurrentSubmenu: function (index) {
    var newIndex = index || 0
    this.set({
      onSubmenu: newIndex,
    })
  },
  showDetailPage: function (status, subtitle) {
    var newStatus = status === false ? false : true
    this.set({
      isDetailPage: newStatus,
      subTitle: subtitle,
    })
  },
  sync: function (method, model, options) {
    if (method === 'read') {
      var list = store.list.get('hotdeal')
      options.success({
        onSubmenu: 0,
        hotdeal: list && list.length > 0,
      })
    }
  },
})
